import React from 'react';
interface PageHeaderProps {
  eyebrow: string;
  title: string;
  description: string;
}
export function PageHeader({
  eyebrow,
  title,
  description
}: PageHeaderProps) {
  return <section className="bg-navy-950" data-id="element-299" data-mp="3rem0zk4adgrx">
      <div className="mx-auto max-w-7xl px-6 py-14 sm:py-16" data-id="element-300" data-mp="3rdkiwvouru0p">
        <p className="text-sm font-semibold uppercase tracking-[0.16em] text-gold-400" data-id="element-301" data-mp="3mfsjlglvp5mh">
          {eyebrow}
        </p>
        <h1 className="mt-4 max-w-3xl font-display text-4xl font-extrabold leading-[1.1] tracking-tight text-white sm:text-5xl" data-id="element-302" data-mp="2yp5a4qwbe7xt">
          {title}
        </h1>
        <p className="mt-5 max-w-2xl text-lg leading-relaxed text-navy-200" data-id="element-303" data-mp="2tp0s2wfrd55h">
          {description}
        </p>
      </div>
    </section>;
}